<template>
  <transition name="modal" @after-enter="modalVisible = true" @after-leave="modalVisible = false">
    <div class="modal-mask">
      <div class="modal-container" :class="whichModal" v-click-outside="closeModal">
        <div class="modal-close" @click="closeModal()">
          <close-x></close-x>
        </div>
        <div class="modal-body">
          <div class="modal-body-content">
            <slot name="body">
              default body
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import store from '../store'
import CloseX from '../assets/icons/modal-close.svg?inline'
import vClickOutside from 'v-click-outside'

export default {
  name: 'modal',
  data(){
    return {
      modalVisible: false
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    'close-x': CloseX
  },
  computed: {
    whichModal() {
      return store.state.modalId
    },
  },
  methods: {
    closeModal() {
      if (this.modalVisible) {
        store.commit('closeModal')
      }
    }
  }
}
</script>

<style scoped lang="scss">

@import '../theme';

.modal-close {
  height: 22px;
  width: 20px;
  @include bg(contain);
  position: absolute;
  top: 40px;
  right: 0;
  cursor: pointer;
  svg {
    fill: white;
  }
  
  @include media-breakpoint-up(lg) {
    top: -30px;
  }
}

.rules .modal-close{
  top: -40px;
  right: 20px;
}

.commercials {
  .modal-close {
    top: -30px;
  }
}

.modal-mask {
  position: fixed;
  z-index: zespri-layer(modal);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 1;
  display: flex;
  transition: opacity .3s ease;
  justify-content: center;
  align-items: center;
  background-color: rgba(zespri-brand-color(dark-green), .85);
}

.modal-container {
  margin: 0px 30px;
  color: white;
  transition: all .3s ease;
  position: relative;
  
  @include media-breakpoint-up(md) {
    max-width: calc(75vw - 40px);
    max-height: calc(100% - 250px);
  }
}

.modal-body {
  height: 100%;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
